import { fetchData } from "./fetchData";

export const getLeagueByID = async (leagueID) => {
  try {
    const route = `/leagues/${leagueID}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAllLeagues = async (query = "") => {
  try {
    const route = `/leagues${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getDDLeagueNames = async () => {
  try {
    const route = `/leagues/dd`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const createLeauge = async (formData) => {
  try {
    const route = `/leagues`;

    const options = {
      method: "POST",
      Headers: {
        "Content-Type": "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateLeauge = async (id, formData) => {
  try {
    const route = `/leagues/${id}`;

    const options = {
      method: "PUT",
      Headers: {
        "Content-Type": formData instanceof FormData ? "multipart/form-data" : "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};
